import { Text } from '../../../../../cdl/Text/Text';
import { queries } from '../../../../../common/api/queryKeys/queries';
import { AttachmentsInfoPopover } from '../../../../../common/Attachments/components/AttachmentsInfoPopover';
import { translate } from '../../../../../common/helpers/translate.helper';
import { useFlags } from '../../../../../common/launchDarkly/useFlags';
import { ReadOnlyProductTable } from '../../../../../common/ReadOnlyProductTable/ReadOnlyProductTable';
import { Box } from '../../../../../common/ui/Box';
import { OfferActivityTimeline } from '../../../../../offer/OfferChat/OfferActivityTimeline';
import { OfferChat } from '../../../../../offer/OfferChat/OfferChat';
import { OfferChatWrapper } from '../../../common/OfferCard/OfferChatWrapper';
import { OfferCompareAttachments } from '../../../common/OfferCard/OfferCompareAttachments';
import { useOfferCardContext } from '../../../components/OfferCard/hooks/useOfferCardContext';

export const OfferAccordionContent = () => {
    const { offer, onboarding } = useOfferCardContext();
    const flags = useFlags();

    return (
        <Box display="flex">
            <Box
                display="flex"
                width={flags.activityLog ? '100%' : '80%'}
                minHeight="400px"
                padding={32}
                rowGap={24}
                flexDirection="column"
            >
                <Text variant="title" as="h2">
                    {translate('offer.detail.products')}
                </Text>

                <ReadOnlyProductTable
                    items={offer.items}
                    sampleKits={offer.samplekits}
                    surcharges={offer.surcharges}
                    showPrices
                />

                <Box flex="auto">
                    <Box display="flex" flexDirection="column" paddingBottom={16} gap={16}>
                        <Box display="flex" alignItems="center" gap={4}>
                            <Text variant="title" as="h2">
                                {translate('offer.detail.attachments')}
                            </Text>
                            <AttachmentsInfoPopover />
                        </Box>
                    </Box>

                    <OfferCompareAttachments
                        offer={offer}
                        onboarding={onboarding}
                        invalidationQueryKey={
                            queries.offers.list({
                                orderIds: [offer.orderId],
                            }).queryKey
                        }
                    />
                </Box>

                {flags.activityLog ? (
                    <Box>
                        <Box paddingBottom={16}>
                            <Text variant="title" as="h2">
                                {translate('offer.detail.activity')}
                            </Text>
                        </Box>

                        <OfferActivityTimeline offer={offer} />
                    </Box>
                ) : null}
            </Box>

            {flags.activityLog ? null : (
                <OfferChatWrapper>
                    <OfferChat offer={offer} />
                </OfferChatWrapper>
            )}
        </Box>
    );
};
